"use strict";

require("core-js/modules/es.error.cause.js");

require("core-js/modules/es.array.push.js");

function n(n, r) {
  for (var i = 0; i < r.length; i++) {
    var e = r[i];
    e.enumerable = e.enumerable || !1, e.configurable = !0, "value" in e && (e.writable = !0), Object.defineProperty(n, e.key, e);
  }
}

require("core-js/modules/es.error.cause.js"), require("core-js/modules/es.array.push.js");

var r = function () {
  function r(n, i) {
    !function (n, r) {
      if (!(n instanceof r)) throw new TypeError("Cannot call a class as a function");
    }(this, r), this._ctx = n, this._options = i, this._listeners = {};
  }

  var i, e, t;
  return i = r, e = [{
    key: "plugin",
    value: function (n, r) {
      var i = this;
      if (n) if (Array.isArray(n)) n.forEach(function (n) {
        return i.plugin(n, r);
      });else {
        var e = this._listeners[n] || [];
        e.push(r), this._listeners[n] = e;
      }
    }
  }, {
    key: "apply",
    value: function (n) {
      var r = this;
      n && (Array.isArray(n) ? n.forEach(function (n) {
        return r.apply(n);
      }) : n.install && "function" == typeof n.install && n.install(this));
    }
  }, {
    key: "applyPlugins",
    value: function (n) {
      for (var r = this, i = arguments.length, e = new Array(i > 1 ? i - 1 : 0), t = 1; t < i; t++) e[t - 1] = arguments[t];

      var l = this._listeners[n];
      l && 0 !== l.length && l.forEach(function (n) {
        n.apply(void 0, [r._ctx].concat(e));
      });
    }
  }, {
    key: "applyPluginsWaterfall",
    value: function (n, r) {
      for (var i = arguments.length, e = new Array(i > 2 ? i - 2 : 0), t = 2; t < i; t++) e[t - 2] = arguments[t];

      var l = this._ctx,
          a = this._listeners[n];
      if (!a || 0 === a.length) return r;
      var s = r;
      return a.forEach(function (n) {
        s = n.apply(void 0, [l, s].concat(e));
      }), s;
    }
  }, {
    key: "applyPluginsAsyncWaterfall",
    value: function (n, r) {
      for (var i = arguments.length, e = new Array(i > 2 ? i - 2 : 0), t = 2; t < i; t++) e[t - 2] = arguments[t];

      var l = this._listeners[n];
      if (!l || 0 === l.length) return Promise.resolve(r);
      var a = this._ctx,
          s = l.length - 1;
      return new Promise(function (n) {
        !function r(i, t) {
          try {
            l[i].apply(void 0, [a, t].concat(e, [function (e) {
              i < s ? r(i + 1, e) : n(e);
            }]));
          } catch (r) {
            console.error("Run plugin failed", r), n(t);
          }
        }(0, r);
      });
    }
  }, {
    key: "dispose",
    value: function () {
      this._ctx = null, this._options = null, this._listeners = [];
    }
  }], e && n(i.prototype, e), t && n(i, t), r;
}(),
    i = {
  mixin: {
    props: {
      plugins: Array
    },
    created: function () {
      if (!this._pluginMgr) {
        var n = this.plugins;
        this._pluginMgr = new r(this), this._pluginMgr.apply(n || []);
      }
    },
    beforeDestroy: function () {
      this._pluginMgr && this._pluginMgr.dispose();
    },
    methods: {
      $applyPlugins: function (n) {
        var r;

        if (this._pluginMgr) {
          for (var i = arguments.length, e = new Array(i > 1 ? i - 1 : 0), t = 1; t < i; t++) e[t - 1] = arguments[t];

          return (r = this._pluginMgr).applyPlugins.apply(r, [n].concat(e));
        }

        console.warn("no plugin manager installed");
      },
      $applyPluginsWaterfall: function (n, r) {
        var i;

        if (this._pluginMgr) {
          for (var e = arguments.length, t = new Array(e > 2 ? e - 2 : 0), l = 2; l < e; l++) t[l - 2] = arguments[l];

          return (i = this._pluginMgr).applyPluginsWaterfall.apply(i, [n, r].concat(t));
        }

        console.warn("no plugin manager installed");
      },
      $applyPluginsAsyncWaterfall: function (n, r) {
        var i;
        if (!this._pluginMgr) return console.warn("no plugin manager installed"), Promise.resolve(r);

        for (var e = arguments.length, t = new Array(e > 2 ? e - 2 : 0), l = 2; l < e; l++) t[l - 2] = arguments[l];

        return (i = this._pluginMgr).applyPluginsAsyncWaterfall.apply(i, [n, r].concat(t));
      }
    }
  },
  PluginManager: r
};

module.exports = i;